import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class GpaoService {

  constructor(private http : HttpClient, private tokenService : TokenService) { }


  debutLigne (options) {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/gpao/debutPause";
    var jsonObject = {options : options}
    return this.http.post(request, jsonObject, {headers : httpHeaders });
  }


  finLigne (options) {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/gpao/finPause";
    var jsonObject = {options : options}
    return this.http.post(request, jsonObject, {headers : httpHeaders });
  }
}
